<template>
    <div class="m-auto max-w-lg">
        <div class="flex flex-wrap md:flex-no-wrap mb-3">
            <div class="card-panel text-dark-charcoal system-border w-full md:w-1/2 md:mr-3 mb-3 md:mb-0">
                <div class="font-size-25 flex items-center">
                    <i class="fas fa-dollar-sign bg-dark-charcoal shadow-text-none icon mr-2"></i>
                    <span class="shadow-text-none">
                        {{ $t('affiliate_point', { point: point.toFixed(2), s: point > 1 ? 's' : '' }) }}
                    </span>
                </div>
            </div>
            <div class="card-panel text-dark-charcoal system-border w-full md:w-1/2">
                <div class="font-size-25 flex items-center">
                    <i class="fas fa-users bg-dark-charcoal shadow-text-none icon mr-2"></i>
                    <span class="shadow-text-none">
                        {{
                            $t('affiliate_user_count', {
                                count: suggestedUserCount,
                                s: suggestedUserCount > 1 ? 's' : ''
                            })
                        }}
                    </span>
                </div>
            </div>
        </div>
        <div class="w-ful mb-4">
            <label class="system-text-color input-label" for="phone">
                {{ $t('affiliate_url') }}
            </label>
            <input
                v-model="affiliateUrl"
                :readonly="true"
                name="affiliate"
                style="border-radius: 0.25rem"
                class="input input-block input-text-center system-border"
                type="text"
            />
        </div>

        <div class="text-center py-5">
            <div class="btn-group">
                <a
                    @click="fetchAffiliate('point')"
                    :class="{ active: isAffiliateActive, 'font-size-14 md:font-size-16': true }"
                >
                    <div class="flex items-center">
                        <div class="sm:hidden font-size-24"><i class="fas fa-check-square"></i></div>
                        <span class="hidden sm:block">{{ $t('my_quiz_tab_point') }}</span>
                    </div>
                </a>
                <a
                    @click="fetchAffiliate('payout')"
                    :class="{ active: isPayoutActive, 'font-size-14 md:font-size-16': true }"
                >
                    <div class="flex items-center">
                        <div class="sm:hidden font-size-24"><i class="fas fa-share-alt"></i></div>
                        <span class="hidden sm:block">{{ $t('my_quiz_tab_payout') }}</span>
                    </div>
                </a>
            </div>
        </div>

        <div v-if="!affiliateLists.length && isAffiliateActive" class="empty-container">
            <h4 class="system-text-color system-text-shadow text-center md:font-size-22 py-12">
                {{ $t('my_quiz_no_partner') }}
            </h4>
        </div>
        <div v-if="!payoutLists.length && isPayoutActive" class="empty-container">
            <h4 class="system-text-color system-text-shadow text-center md:font-size-22 py-12">
                {{ $t('my_quiz_no_payout') }}
            </h4>
        </div>
        <div v-if="affiliateLists.length && isAffiliateActive" class="max-w-xl m-auto">
            <label class="system-text-color input-label" for="phone">
                {{ $t('affiliate_point_history') }}
            </label>
            <div
                v-for="(affiliate, index) in affiliateLists"
                :key="index"
                :class="{ 'report-download-modal': screenWidth <= 768 ? true : false }"
                class="text-dark-charcoal system-border bg-white block md:flex md:flex-wrap lg:flex-no-wrap report-row p-4 mb-2"
            >
                <div class="flex justify-start lg:justify-start items-start md:w-1/3 lg:w-full mb-2 sm:mb-0">
                    <div class="mr-2 py-2">
                        <i class="far fa-user shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{ affiliate.user.name }}</strong>
                        <span class="font-size-14 shadow-text-none">
                            {{
                                affiliate.type == 'register'
                                    ? $t('affiliate_type_register')
                                    : affiliate.type == 'subscription_year'
                                    ? $t('affiliate_type_subscribe_by_year')
                                    : $t('affiliate_type_subscribe_by_month')
                            }}
                        </span>
                    </div>
                </div>

                <div class="flex justify-start items-start md:w-1/3 lg:w-full mb-2">
                    <div class="mr-3 py-2">
                        <i class="far fa-calendar shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{ $t('affiliate_date_time') }}</strong>
                        <span class="font-size-14 shadow-text-none" style="text-transform: capitalize">
                            {{ affiliate.created_at_readable }}
                        </span>
                    </div>
                </div>

                <div class="flex justify-start lg:justify-center items-start md:w-1/3 lg:w-full mb-2 sm:mb-0">
                    <div class="mr-2 py-2">
                        <i class="fas fa-dollar-sign shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{
                            $t('affiliate_point_by_user', { s: suggestedUserCount > 1 ? 's' : '' })
                        }}</strong>
                        <span class="font-size-14 shadow-text-none">
                            {{ affiliate.point.toFixed(2) }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 my-3">
                <Paginator
                    @pagination-change="onPageChange"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    :total-items="totalItems"
                />
            </div>
        </div>

        <div v-if="payoutLists.length && isPayoutActive" class="max-w-xl m-auto">
            <label class="system-text-color input-label" for="phone">
                {{ $t('affiliate_payout_history') }}
            </label>
            <div
                v-for="(payout, index) in payoutLists"
                :key="index"
                :class="{ 'report-download-modal': screenWidth <= 768 ? true : false }"
                class="text-dark-charcoal system-border bg-white block md:flex md:flex-wrap lg:flex-no-wrap report-row p-4 mb-2"
            >
                <div class="flex justify-start items-start md:w-1/3 lg:w-full mb-2">
                    <div class="mr-3 py-2">
                        <i class="far fa-calendar shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{ $t('affiliate_date_time') }}</strong>
                        <span class="font-size-14 shadow-text-none" style="text-transform: capitalize">
                            {{ payout.created_at_readable }}
                        </span>
                    </div>
                </div>

                <div class="flex justify-start lg:justify-center items-start md:w-1/3 lg:w-full mb-2 sm:mb-0">
                    <div class="mr-2 py-2">
                        <i class="fas fa-dollar-sign shadow-text-none font-size-22"></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{
                            $t('affiliate_point_by_user', { s: suggestedUserCount > 1 ? 's' : '' })
                        }}</strong>
                        <span class="font-size-14 shadow-text-none">
                            {{ payout.point.toFixed(2) }} = {{ payout.amount }} USD
                        </span>
                    </div>
                </div>

                <div class="flex justify-start items-start md:w-1/3 lg:w-full mb-2">
                    <div class="mr-3 py-2">
                        <i
                            v-if="payout.status.name == 'paid'"
                            class="fas fa-check-circle shadow-text-none font-size-22 color-green"
                        ></i>
                        <i
                            v-if="payout.status.name == 'cancel'"
                            class="fas fa-times-circle shadow-text-none font-size-22 color-red"
                        ></i>
                    </div>
                    <div>
                        <strong class="block font-size-16">{{ $t('affiliate_status') }}</strong>
                        <span class="font-size-14 shadow-text-none" style="text-transform: capitalize">
                            {{ payout.status.name === 'cancel' ? $t('affiliate_cancelled') : $t('affiliate_paid') }}
                        </span>
                        <i
                            v-if="payout.status.name == 'cancel'"
                            @click="onSeeReason(index)"
                            class="font-size-12 shadow-text-none cursor-pointer font-normal"
                            style="text-transform: capitalize"
                        >
                            ({{ $t('affiliate_see_reason') }})
                        </i>
                        <span
                            :id="'show-reason-' + index"
                            class="font-size-12 shadow-text-none cursor-pointer"
                            style="text-transform: capitalize; display: none"
                        >
                            {{ payout.reason }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 my-3">
                <Paginator
                    @pagination-change="onPageChangePayout"
                    :current-page="currentPagePayout"
                    :page-count="pageCountPayout"
                    :total-items="totalItemsPayout"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Request from '@/lib/request'
import helper from '@/lib/helper.js'
import appConfig from '@/app.config'
import UserService from '@/lib/user'
import Paginator from '@/components/Paginator'
import Url from '@/lib/url'
import introJsData from '@/mixins/introjs-data'
import { startIntroAffiliate } from '@/lib/intro.js'

export default {
    components: { Paginator },

    mixins: [introJsData],

    computed: {
        isDesktop() {
            return helper.desktop()
        }
    },

    data() {
        return {
            currentPage: 1,
            pageCount: 0,
            totalItems: 0,

            currentPagePayout: 1,
            pageCountPayout: 0,
            totalItemsPayout: 0,

            affiliateLists: [],
            screenWidth: 0,
            point: 0,
            suggestedUserCount: 0,
            affiliateUrl: '',
            baseURL: process.env.VUE_APP_API_BASE_URL.replace('api', 'aff'),
            payoutLists: [],
            isAffiliateActive: true,
            isPayoutActive: false
        }
    },

    created() {
        var url = new Url()

        if (this.$route.query.type_affiliate == 'point') {
            this.isAffiliateActive = true
            this.isPayoutActive = false
        } else {
            this.isAffiliateActive = false
            this.isPayoutActive = true
        }

        this.getAffiliate(url.buildQuery())
        this.getPayoutByUser(url.buildQuery())
    },

    watch: {
        $route() {
            const url = new Url()

            if (this.$route.query.type_affiliate == 'point') {
                this.isAffiliateActive = true
                this.isPayoutActive = false
            } else {
                this.isAffiliateActive = false
                this.isPayoutActive = true
            }

            if (this.isAffiliateActive) {
                this.getAffiliate(url.buildQuery())
            }

            if (this.isPayoutActive) {
                this.getPayoutByUser(url.buildQuery())
            }
        }
    },

    mounted() {
        const url = new Url()

        this.$router.replace({
            name: this.$router.currentRoute.name,
            query: url.buildQuery()
        })

        this.screenWidth = screen.width

        const userService = new UserService()
        const affiliateCode = userService.getUser().affiliate_code

        this.affiliateUrl = this.baseURL + affiliateCode

        //show intro affiliate
        setTimeout(() => {
            startIntroAffiliate(this.stepTour13)
        }, 700)
    },

    methods: {
        onSeeReason(index) {
            const rawBox = document.querySelector('#show-reason-' + index)

            if (rawBox.style.display == 'none') {
                rawBox.style.display = 'block'
            } else {
                rawBox.style.display = 'none'
            }
        },

        fetchAffiliate(val) {
            var url = new Url()
            var urlParams = new URL(window.location.href)
            var page = 1

            urlParams.searchParams.set('type_affiliate', val)
            window.history.replaceState(null, null, urlParams.toString())

            this.$router.replace({
                name: this.$router.currentRoute.name,
                query: url.buildQuery({ page })
            })

            if (val == 'point') {
                this.isAffiliateActive = true
                this.isPayoutActive = false

                this.getAffiliate(url.buildQuery())
            }

            if (val == 'payout') {
                this.isAffiliateActive = false
                this.isPayoutActive = true

                this.getPayoutByUser(url.buildQuery())
            }
        },

        onPageChange(page) {
            this.currentPage = page
            const urlParams = new URL(window.location.href)

            urlParams.searchParams.set('page', this.currentPage)
            window.history.replaceState(null, null, urlParams.toString())

            this.getAffiliate(urlParams.searchParams)

            document.getElementById('app').scrollTo(0, 0)
        },

        onPageChangePayout(page) {
            this.currentPage = page
            const urlParams = new URL(window.location.href)

            urlParams.searchParams.set('page', this.currentPage)
            window.history.replaceState(null, null, urlParams.toString())

            this.getPayoutByUser(urlParams.searchParams)

            document.getElementById('app').scrollTo(0, 0)
        },

        getAffiliate(params) {
            const request = this.createRequest()
            const url = appConfig.api.getAffiliateAllByUserPartner
            this.$store.commit('toggleMainLoader', true)

            request.get(url, { params }).then(res => {
                this.affiliateLists = res.data.data.data
                this.pageCount = parseInt(res.data.data.page_count)
                this.currentPage = parseInt(res.data.data.current_page)
                this.totalItems = parseInt(res.data.data.total)
                this.suggestedUserCount = parseInt(res.data.data.number_of_user)
                this.point = parseFloat(res.data.data.point)

                this.$store.commit('toggleMainLoader', false)
            })
        },

        getPayoutByUser(params) {
            const request = this.createRequest()
            const url = appConfig.api.getPayoutByUser
            this.$store.commit('toggleMainLoader', true)

            request.get(url, { params }).then(res => {
                this.payoutLists = res.data.data.data
                this.pageCountPayout = parseInt(res.data.data.page_count)
                this.currentPagePayout = parseInt(res.data.data.current_page)
                this.totalItemsPayout = parseInt(res.data.data.total)

                this.$store.commit('toggleMainLoader', false)
            })
        },
        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        }
    }
}
</script>


<style lang="scss">
.card-panel {
    background-color: #fff;
    border-radius: 0.25rem;
    padding: 1rem;

    .icon {
        width: 2.3rem;
        height: 2.3rem;
        border-radius: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8em;
    }
}

.btn-group {
    border-radius: 0.5rem;
    overflow: hidden;
    display: inline-block;
    border: 2px solid var(--ui-primary-color);

    > a {
        color: var(--text-color);
        padding: 7px 15px;
        display: inline-block;
        cursor: pointer;

        span,
        i {
            text-shadow: var(--text-shadow) !important;
        }

        > span {
            transition: 0.3s;
        }

        > div {
            transition: transform 0.3s;
        }

        &:hover {
            > div {
                transform: translateY(-2px);
            }
        }

        &.active {
            background-color: var(--ui-primary-color);
            color: var(--ui-secondary-color);
        }
    }
}

.color-red {
    color: red;
}

.color-green {
    color: green;
}
</style>
